const FormType = {
  Quotations: {
    id: 1,
    name: "Quotations",
  },
  ProductsAndServices: {
    id: 2,
    name: "ProductsAndServices",
  },
  LeadNotes: {
    id: 3,
    name: "LeadNotes",
  },
  LeadFiles: {
    id: 4,
    name: "LeadFiles",
  },
  LeadEmails: {
    id: 5,
    name: "LeadEmails",
  },
  Invoice: {
    id: 6,
    name: "Invoice",
  },
  Employee: {
    id: 7,
    name: "Employee",
  },
  MappedCompany: {
    id: 8,
    name: "MappedCompany",
  },
  Appointments: {
    id: 9,
    name: "Appointments",
  },
  AppointmentSignature: {
    id: 10,
    name: "AppointmentSignature",
  },
  WorkOrder: {
    id: 11,
    name: "WorkOrder",
  },
  SubContractorLicense: {
    id: 12,
    name: "SubContractorLicense",
  },
  SubContractorInsurance: {
    id: 13,
    name: "SubContractorInsurance",
  },
};

export default FormType;
